/****************************************************
 * Module Name:  labTesting.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, FormControlLabel, FormGroup, Switch, Tooltip, Typography, Stack, } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import LabProxy from "../../utility/proxy/manager/labProxy";
import StoneLabstatusProxy from "../../utility/proxy/manager/stoneLabStatusProxy";
import { useEffect } from "react";
import Select from "react-select";
import CircularProgress from "@mui/material/CircularProgress";
import LabTestProxy from "../../utility/proxy/manager/labTestProxy";
import { ThemeProvider, createTheme } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Constants from "../../utility/constants";
import StoneDetailModal from "../common/stoneDetailModal";
import UserProxy from "../../utility/proxy/manager/userProxy";
import { LoadingButton } from "@mui/lab";
import TabMenuSnackbar from "./tabMenuSnackbar";
import TotalStockComponent from "./totalStockComponent";
import CommonStoneSelection from "./commonStoneSelection";
import PageTitle from "./pageTitle";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";


const defaultOptions = { value: "*", label: "-- ANY --" };

const LabTestingComponent = ({ closeStatus, reportLoad, userDropdown }) => {
  const [lab, setLab] = useState([]);
  const [labOption, setLabOption] = useState([]);

  const [status, setStatus] = useState([]);
  const [statusOption, setStatusOption] = useState([]);

  const [listData, setListData] = useState([]);
  const [mainData, setMainData] = useState([]);

  const [testingListLoader, setTestingListLoader] = useState(false);
  const [fetchData, setFetchData] = useState(false);

  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);

  const [user, setUser] = useState([]);
  const [userOption, setUserOption] = useState([]);

  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const [columnNames, setColumnNames] = React.useState([]);

  //top most summary table 
  const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
  const [selectedTotalSize, setSelectedTotalSize] = useState("0");
  const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
  const [selectedavgPrice, setSelectedavgPrice] = useState("0");
  const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");

  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [userIds, setUserIds] = useState([]);

  const fullOptionToValue = (selectedData, optionArr) => {
    if (selectedData.value === "*")
      return Utility.GetValueArrayWithoutStar(optionArr);

    return Utility.GetValueArrayWithStarReplace(
      selectedData,
      Utility.GetValueArrayWithoutStar(optionArr)
    );
  };

  const [groupBy, setGroupBy] = useState(true);
  const [selectionModel, setSelectionModel] = useState([]);
  const [filterValues, setFilterValues] = useState({});


  useEffect(() => {
    PageTitle("OPERATION_LAB_LABTESTING");
    getAllLabData();
    getAllStatusData();
    getAllUserData();
  }, []);

  const getAllLabData = () => {
    LabProxy.GetAllLab((response) => {
      setAllLabData(response);
    });
  };

  const getAllStatusData = () => {
    StoneLabstatusProxy.GetAllStoneLabstatusMini((response) =>
      setAllStatusData(response)
    );
  };

  const getAllUserData = () => {
    UserProxy.GetAllEmployeeMini("", (response) => {
      setAllUserData(response);
    });
  };

  const setAllLabData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.name + " | " + data.location + " | " + data.country,
      };
      optionsArray.push(option);
      return true;
    });
    setLabOption(optionsArray);
    setLab(lab.length === 0 && optionsArray.length > 0 ? optionsArray[0] : lab);
    setFetchData(true);
  };

  const setAllStatusData = (response) => {
    let optionsArray = [];
    let selectedOption = [];
    optionsArray.push(defaultOptions);
    response.map((data) => {
      let option = { value: data.status, label: data.status };
      optionsArray.push(option);

      if (data.status === "SENT") selectedOption.push(option);

      return true;
    });

    if (closeStatus) {
      optionsArray.push({ value: "CLOSED", label: "CLOSED" });
    }

    if (selectedOption.length === 0) selectedOption.push(defaultOptions);

    setStatusOption(optionsArray);
    setStatus(selectedOption);
    setFetchData(true);
  };

  useEffect(() => {
    if (fetchData && reportLoad === false) {
      if (lab.value && status.length > 0) {
        handleSearch(lab, status);
      }
    } else {
      if (fetchData) {
        if (lab.value && status.length > 0 && user) {
          handleSearchReport(lab, status, user);
        }
      }
    }
  }, [fetchData, lab, status]);

  useEffect(() => {
    if (selectionModel.length <= 0) {
      loadTotalData(listData);
      return;
    }
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size
    listData.forEach((iData) => {
      if (selectionModel.includes(`${iData.batchid}-${iData.stoneid}`)) {
        let pricePerCarat = iData.price
        totalSize += iData.size;
        totalPrice += (iData.size * pricePerCarat);
        total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
      }
    });
    setNoOfSelectedStones(selectionModel.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );

  }, [selectionModel]);

  const loadTotalData = (data) => {
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size

    data.forEach((iData) => {
      let pricePerCarat = iData.price
      totalSize += iData.size;
      totalPrice += (iData.size * pricePerCarat);
      total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

    });
    setNoOfSelectedStones(data.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  };

  const handleSearch = (llab, lstatus) => {
    let statuss = fullOptionToValue(lstatus, statusOption);
    setTestingListLoader(true);
    LabTestProxy.GetAllTestingStonesInALabDetail(
      llab.value,
      statuss,
      (response) => {
        if (response) {
          const distinctStatus = Utility.getDistinctOptions(response, 'status');
          const uniqueFilterValues = {
            createdby: Utility.getDistinctOptions(response, "first_name"),
            created: Utility.getDistinctOptions(response, "username"),
          };
          setFilterValues(uniqueFilterValues);
          prepareColumns(distinctStatus);
          setListData(response);
          handleArray(response);
          if (!groupBy) {
            loadTotalData(response);
          }
          setTestingListLoader(false);
          setFetchData(false);
        } else {
          setErrorSnackbar(true);
          setTestingListLoader(false);
        }
      }
    );
  };

  const handleSearchReport = (llab, lstatus, user) => {
    let statuss = fullOptionToValue(lstatus, statusOption);
    let userIds = fullOptionToValue(user, userOption);
    setTestingListLoader(true);
    LabTestProxy.GetAllTestingStonesInALabDetailReport(
      llab.value,
      statuss,
      userIds,
      (response) => {
        if (response) {
          const distinctStatus = Utility.getDistinctOptions(response, 'status');
          prepareColumns(distinctStatus);
          setListData(response);
          handleArray(response);
          setTestingListLoader(false);
          setFetchData(false);
        } else {
          setErrorSnackbar(true);
          setTestingListLoader(false);
        }
      }
    );
  };

  const setAllUserData = (response) => {
    let optionsArray = [];
    optionsArray.push({ value: "*", label: "-- ANY --" });
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.username,
      };
      optionsArray.push(option);
      return true;
    });
    setUserIds(optionsArray.filter(option => option.value !== "*").map(option => option.value));
    setUserOption(optionsArray);
    setUser(user.length === 0 && optionsArray.length > 0 ? optionsArray[0] : user);

    setFetchData(true);
  };

  const handleArray = (lListData) => {
    let listIdTracker = 0;
    let newMainData = [];
    if (lListData.length > 0) {
      lListData
        .sort((a, b) => a.id - b.id)
        .map((list) => {
          if (listIdTracker === 0 || list.id !== listIdTracker) {
            listIdTracker = list.id;
            newMainData.push({
              id: list.id,
              createdat: list.createdat,
              createdby: list.username,
              createdbyname: list.first_name,
              labname: list.labname,
              labcity: list.location,
              labcountry: list.country,
              remark: list.remark,
              sentstonecount: list.sentstonecount,
              reportreceivedstonecount: list.reportreceivedstonecount,
              stonereceivedstonecount: list.stonereceivedstonecount,
            });
          }
          return true;
        });
    }

    setMainData(newMainData);
  };

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const handleClose = () => {
    setShowStoneDetailModal(false);
  };

  const handleSelection = (data) => {
    const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, listData, selectionModel);

    setListData(tempStockData);
    setSelectionModel(tempSelectionModel);
  }

  const prepareColumns = (distinctStatus) => {
    let columnNames = [];

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        if (columnData.field === "status") {
          columnData.type = "singleSelect";
          columnData.valueOptions = distinctStatus;
          columnData.filterOperators = Utility.combinedFilters();
        }
        columnNames.push(columnData);
        if (columnData.field === "stoneid") {
          columnNames.push({
            field: "suratid",
            headerName: "SURATID",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
          })
        }
      }
    });
    setColumnNames(columnNames);
  }

  const columnsData = {
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      width: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 110,
      renderCell: renderCellExpand,
      editable: true,
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "right",
      width: 40,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "rapnetprice",
      headerName: "RAP",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 50,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount),
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
    },
    "6defca68-d5d9-4c30-ae83-938a01f45a07": {
      field: "colortype",
      headerName: "COL TYPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 65,
      renderCell: renderCellExpand,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 75,
      renderCell: renderCellExpand,
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 50,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 40,
      renderCell: renderCellExpand,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 40,
      renderCell: renderCellExpand,
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 60,
      renderCell: renderCellExpand,
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
      field: "width",
      headerName: "WIDTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "d4992de9-92ab-4f9e-ba12-6c746e935611": {
      field: "colordescriptions",
      headerName: "COL DESCRIP",
      headerAlign: "center",
      align: "center",
      width: 110,
      renderCell: renderCellExpand,
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "19ce7030-402c-495c-84ac-a29093bdb0ac": {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 120,
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 100,
      renderCell: renderCellExpand,
    },
    "f97a0118-3891-4f77-abf7-8636c26d594c": {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
      field: "height",
      headerName: "HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "e7210f4a-6e0a-4591-8428-e6845004ed04": {
      field: "crownheight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
      field: "culetsize",
      headerName: "CULET SZ",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "e3f77521-2c57-46bc-a02b-3c884685d2be": {
      field: "culetcondition",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "e83c2978-9088-49f0-9dc1-bcced73025fd": {
      field: "gridlemin",
      headerName: "GIRDLEMIN",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
      field: "intensitylongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "06d2a589-0d42-4dde-8724-acf2448c839a": {
      field: "laserinscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    "dd934505-1865-48cb-878f-f5d3c18af2d5": {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "e9028170-e978-4978-a2c9-1889c1821495": {
      field: "gridlecondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
      field: "gridlepercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
      field: "pavilionangle",
      headerName: "PV.ANGLE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
  };

  const defaultColumns = [
    {
      headerName: "BATCH ID",
      field: "id",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    {
      headerName: "CREATED AT",
      field: "createdat",
      headerAlign: "center",
      align: "center",
      width: 180,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      headerName: "CREATED BY",
      field: "createdby",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.created : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      headerName: "CREATED BY NAME",
      field: "createdbyname",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.createdby : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      headerName: "LAB NAME",
      field: "labname",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },

    {
      headerName: "LAB CITY",
      field: "labcity",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      headerName: "LAB COUNTRY",
      field: "labcountry",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: renderCellExpand,
    },
    {
      headerName: "SENT",
      field: "sentstonecount",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => params.value === null ? 0 : params.value
    },

    {
      headerName: "REPORT RECEIVED",
      field: "reportreceivedstonecount",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => params.value === null ? 0 : params.value
    },
    {
      headerName: "STONE RECEIVED",
      field: "stonereceivedstonecount",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => params.value === null ? 0 : params.value
    },
    {
      headerName: "REMARK",
      field: "remark",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: renderCellExpand,
    },
  ]


  const columns = columnNames;
  const defaultMaterialTheme = createTheme();

  const getDetailPanelHeight = React.useCallback(() => 'auto', []);

  const getDetailPanelContent = React.useCallback(
    (row, listData) => <DetailPanelContent row={row} listData={listData} />,
    [columns],
  );

  function DetailPanelContent({ row: rowProp, listData }) {
    let rows = listData.filter((data) => data.id === rowProp.id);
    return (
      <Stack
        sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
        direction="column"
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            width: "100%",
            position: "relative",
            "& .MuiTablePagination-selectLabel": {
              marginTop: "15px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "15px",
            },
            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontWeight: Constants.defaultFontWeight,
            },
            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
              color: "#1976d2",
              padding: "4px 5px",
              borderRadius: "4px",
            },
            "& .css-cc8tf1": {
              fontWeight: Constants.defaultFontWeight,
            },
            height: 'auto',
            marginLeft: '16px',
          }}
        >
          <DataGridPro
            disableRowSelectionOnClick={false}
            density="compact"
            columns={columns}
            rows={rows}
            getRowId={(row) => row.stoneid}
            sx={{
              '& .MuiDataGrid-columnHeader': {
                color: '#fff',
                backgroundColor: 'grey',
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "8px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "15px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "22px",
              },
              bgcolor: "#cfd8dc",
              fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  // Hide columns id, the other columns will remain visible
                  approved: false,
                  rejected: false,
                  nextstate: false,
                  remark: false,
                  lab: false,
                  locationid: false,
                  cutpolsym: false,
                  height: false,
                  certificateid: false,
                  crownheight: false,
                  crownangle: false,
                  culetsize: false,
                  culetcondition: false,
                  gridlemin: false,
                  intensitylongtitle: false,
                  note: false,
                  open: false,
                  gridlecondition: false,
                  gridlepercent: false,
                  pavilionangle: false,
                  paviliondepth: false,
                  white: false,
                  laserinscription: false,
                  country: false,
                  quality: false,
                  labname: false,
                  stonelabdetailstatus: false,
                  report: false,
                  resultdate: false,
                  suratid: false
                },
              },
              pagination: {
                paginationModel: Constants.pageSize,
              },
            }}
            pageSizeOptions={Constants.pageSizeOptions}
            pagination
          />
        </Box>
        <Box height={100}>
          <TotalStockComponent data={rows} />
        </Box>
      </Stack>
    );
  }

  return (
    <div>
      <TabMenuSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Failed"}
        handleClose={() => setErrorSnackbar(false)}
      />
      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneId}
          handleClose={handleClose}
        />
      ) : null}
      {reportLoad ?
        <Box
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: "center",
            fontSize: "xx-large",
            paddingBottom: 10,
            paddingTop: 10
          }}
        >
          <Typography id="glass" style={{
            textAlign: "center",
            width: '350px',
            color: '#fff',
            fontSize: "xx-large",
          }}>
            Lab Test Report List
          </Typography>
        </Box> : null}
      {showUserDetailModal ? (
        <UserDetailModal
          show={true}
          handleClose={() => setShowUserDetailModal(false)}
          handleSelect={(selectedOption) => {
            const selectedCustomers = userOption.filter(opt =>
              selectedOption.includes(opt.value)
            );
            setUser(selectedCustomers);
            setShowUserDetailModal(false)
          }}
          userids={userIds}
          selectedIds={user.value !== "*" ? user.map(user => user.value) : []}
          usertype={"E"}
          loading={showUserDetailModal}
          isMulti={true}
        />
      ) : null}
      <Box sx={{ display: "flex", width: "100%", mb: 1, }}>
        <Box
          sx={{
            display: "flex",
            width: "25%",
            gap: "20px",
          }}
        >
          <Box sx={{ alignSelf: "center", mt: 1 }}>
            <Typography>Lab</Typography>
          </Box>
          <Box
            sx={{
              alignSelf: "center",
              width: "80%",
              mt: 1,
            }}
          >
            <Select menuPlacement="auto"
              blurInputOnSelect={false}
              menuPortalTarget={document.body}
              styles={Constants.Styles}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={labOption}
              value={lab}
              onChange={(e) => setLab(e)}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "35%",
            gap: "20px",
          }}
        >
          <Box sx={{ alignSelf: "center", mt: 1 }}>
            <Typography>Status</Typography>
          </Box>
          <Box
            sx={{
              alignSelf: "center",
              minWidth: "80%",
              mt: 1,
            }}
          >
            <Select menuPlacement="auto"
              blurInputOnSelect={false}
              menuPortalTarget={document.body}
              styles={Constants.Styles}
              closeMenuOnSelect={false}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              isMulti
              options={statusOption}
              value={status}
              onChange={(e) => setStatus(e)}
            />
          </Box>
        </Box>
        {userDropdown ? (
          <Box
            sx={{
              display: "flex",
              width: "30%",
              gap: "20px",
            }}
          >
            <Box sx={{ alignSelf: "center", mt: 1 }}>
              <Typography>Users</Typography>
            </Box>
            <Box
              sx={{
                alignSelf: "center",
                width: "100%",
                mt: 1,
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <Select
                menuPlacement="auto"
                blurInputOnSelect={false}
                menuPortalTarget={document.body}
                styles={Constants.Styles}
                isMulti
                closeMenuOnSelect={false}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={userOption}
                value={user}
                onChange={(e) => setUser(e)}
              />
              <Tooltip title="View More Data">
                <span style={{ cursor: "pointer" }}>
                  <OpenInNewIcon
                    style={{ fontSize: '20px', marginBottom: "3px" }}
                    onClick={() => setShowUserDetailModal(true)}
                    color="action"
                  />
                </span>
              </Tooltip>
            </Box>
          </Box>
        ) : null}



        <FormGroup sx={{ mt: 1 }}>
          <FormControlLabel
            control={
              <Switch
                disabled={testingListLoader}
                checked={groupBy}
                onChange={() => {
                  const newGroupBy = !groupBy;
                  setGroupBy(newGroupBy);

                  if (!newGroupBy) {
                    loadTotalData(listData);
                  }

                }}
              />
            }
            label="By Batch Id"
          />
        </FormGroup>

        <Box sx={{ marginTop: "12px", paddingLeft: "55px" }}>
          <LoadingButton
            variant="contained"
            loading={testingListLoader}
            loadingPosition="start"
            disabled={
              userOption.length === 0 ||
              status.length === 0 ||
              lab.length === 0
            }
            onClick={() =>
              reportLoad
                ? handleSearchReport(lab, status, user)
                : handleSearch(lab, status)
            }
            startIcon={<SearchOutlinedIcon size="large" />}
          >
            Search
          </LoadingButton>
        </Box>
      </Box>
      {!groupBy ?
        (
          <div>
            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                width: "100%",
                position: "relative",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                  color: "#1976d2",
                  padding: "4px 5px",
                  borderRadius: "4px",
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                height: '80vh'
              }}
            >
              <DataGridPro
                disableRowSelectionOnClick={true}
                sx={{
                  '& .MuiDataGrid-columnHeader': {
                    color: '#fff',
                    backgroundColor: 'grey',
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                    py: "8px",
                  },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                    py: "15px",
                  },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                    py: "22px",
                  },
                  height: "80vh",
                  fontSize: Constants.defaultTableFontSize, fontWeight: 'bold'
                }}
                density="compact"
                loading={testingListLoader}
                slots={{ toolbar: GridToolbar }}
                rows={listData}
                columns={columns}
                getRowId={(row) => `${row.batchid}-${row.stoneid}`}
                checkboxSelection={true}
                onRowSelectionModelChange={(newSelectionModel) => {
                  setSelectionModel(newSelectionModel);
                }}
                rowSelectionModel={selectionModel}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns id, the other columns will remain visible
                      labname: false,
                      location: false,
                      country: false,
                    },
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />

              <Box sx={{
                position: "absolute",
                left: "0.4rem",
                top: "1px"
              }}>
                <CommonStoneSelection title={"Enter multiple Stone Ids"} handleSelection={handleSelection} bgColor='#454545' buttonDisabled={listData.length === 0} />
              </Box>

              <Box
                sx={{
                  position: "absolute",
                  top: 5,
                  display: 'flex',
                  alignItems: 'center',
                  color: "black",
                  paddingTop: "8px",
                  paddingLeft: "8px",
                  fontWeight: 'normal',
                  left: "36%",
                  fontSize: Constants.defaultTableFontSize
                }}

              ><p>
                  <span>No of Stones: </span> <b>{noOfSelectedStones}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span>Total Weight: </span> <b>{selectedTotalSize}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span>Total Price: </span> <b>{selectedtotalPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span>Avg Price: </span> <b>{selectedavgPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span>Avg Discount: </span> <b>{selectedAvgDiscount}</b></p>

              </Box>
              <Box
                style={{
                  position: "absolute",
                  top: 5,
                  right: "270px",
                  display: "flex",
                  gap: "15px",
                }}
              >

                {testingListLoader ? (
                  <CircularProgress size="1rem" />
                ) : (
                  <Tooltip title="Reload List">
                    <RefreshOutlinedIcon
                      onClick={() => {
                        handleSearch(lab, status)
                      }}
                      color="primary"
                      fontSize="medium"
                      sx={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                )}
              </Box>
            </Box>
          </div>
        ) : (
          <ThemeProvider theme={defaultMaterialTheme}>
            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                width: "100%",
                position: "relative",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .lavenderCell": {
                  color: "#080808",
                  backgroundColor: "#D8BFD8",
                },
                height: "75vh",
              }}
            >
              <DataGridPro
                disableRowSelectionOnClick={false}
                density="compact"
                columns={defaultColumns}
                rows={mainData}
                getRowId={(row) => row.id}
                loading={testingListLoader}
                sx={{
                  '& .MuiDataGrid-columnHeader': {
                    color: '#fff',
                    backgroundColor: 'grey',
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                    py: "4px",
                  },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                    py: "12px",
                  },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                    py: "18px",
                  },
                  '& .MuiDataGrid-row': {
                    whiteSpace: 'nowrap',
                  },
                  fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                }}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [{ field: "id", sort: "desc" }],
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                getDetailPanelHeight={getDetailPanelHeight}
                getDetailPanelContent={({ row }) => getDetailPanelContent(row, listData)}
              />
              <Box
                style={{
                  position: "absolute",
                  top: 5,
                  right: "270px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {testingListLoader ? (
                  <CircularProgress size="1rem" />
                ) : (
                  <Tooltip title="Reload List">
                    <RefreshOutlinedIcon
                      onClick={() =>
                        reportLoad
                          ? handleSearchReport(lab, status, user)
                          : handleSearch(lab, status)
                      }
                      color="primary"
                      fontSize="medium"
                      sx={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                )}
              </Box>
            </Box>
          </ThemeProvider >
        )}

    </div >
  );
};

export default LabTestingComponent;
